<template>
  <div class="sakura-container">
    <!-- 動態生成多個櫻花花瓣 -->
    <div 
      v-for="(petal, i) in petals" 
      :key="i" 
      class="sakura"
      :class="petal.type"
      :style="petalStyle(petal)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'FallingPetals',
  props: {
    petalCount: {
      type: Number,
      default: 150
    },
    minSize: {
      type: Number,
      default: 8     // 縮小最小尺寸
    },
    maxSize: {
      type: Number,
      default: 15    // 縮小最大尺寸
    },
    delay: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      petals: [],
      defaultStyles: {},
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      animationNames: ['fall-1', 'fall-2', 'fall-3']
    }
  },
  mounted() {
    this.createPetals();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.createPetals(); // 重新生成花瓣以適應新的視窗大小
    },
    createPetals() {
      this.petals = [];
      // 創建指定數量的花瓣
      for(let i = 0; i < this.petalCount; i++) {
        this.petals.push(this.createPetal());
      }
    },
    createPetal() {
      // 不再需要不同類型，所有花瓣使用同一類型
      const type = `petal-${Math.floor(Math.random() * 5) + 1}`;
      
      // 隨機大小（微調範圍使所有花瓣更統一）
      const size = this.minSize + Math.random() * (this.maxSize - this.minSize);
      
      // 隨機位置
      const left = Math.random() * this.windowWidth;
      const top = Math.random() * this.windowHeight * -1; // 起始於視窗上方
      
      // 隨機旋轉角度
      const rotation = Math.random() * 360;
      
      // 隨機動畫效果
      const animationName = this.animationNames[Math.floor(Math.random() * this.animationNames.length)];
      
      // 隨機動畫持續時間 (10-25秒)
      const animationDuration = 10 + Math.random() * 15;
      
      // 隨機動畫延遲
      const animationDelay = Math.random() * (this.delay / 100);
      
      // 略微隨機的透明度 (0.6-0.8)
      const opacity = 0.6 + Math.random() * 0.2;
      
      return {
        type,
        size,
        left,
        top,
        rotation,
        animationName,
        animationDuration,
        animationDelay,
        opacity
      };
    },
    petalStyle(petal) {
      return {
        width: `${petal.size}px`,
        height: `${petal.size}px`,
        left: `${petal.left}px`,
        top: `${petal.top}px`,
        transform: `rotate(${petal.rotation}deg)`,
        animation: `${petal.animationName} ${petal.animationDuration}s linear ${petal.animationDelay}s infinite`,
        opacity: petal.opacity
      };
    }
  }
}
</script>

<style>
.sakura-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.sakura {
  position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: visible;
  filter: drop-shadow(0 0 1px rgba(255, 192, 203, 0.2));
  mix-blend-mode: multiply;
}

/* 橢圓葉片狀櫻花花瓣 - 一邊略尖，一邊圓滑 */
.petal-1, .petal-2, .petal-3, .petal-4, .petal-5 {
  background-color: rgba(255, 204, 213, 0.7); /* 淡粉紅色帶透明感 */
  border-radius: 80% 20% 80% 20%; /* 創造橢圓形，一邊尖一邊圓 */
  transform-origin: center;
}

/* 定義三種不同的落下動畫 */
@keyframes fall-1 {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg) scale(1);
  }
  25% {
    transform: translateY(25vh) translateX(10px) rotate(15deg) scale(0.95);
  }
  50% {
    transform: translateY(50vh) translateX(-8px) rotate(30deg) scale(1.05);
  }
  75% {
    transform: translateY(75vh) translateX(8px) rotate(45deg) scale(0.98);
  }
  100% {
    transform: translateY(105vh) translateX(-10px) rotate(60deg) scale(1);
  }
}

@keyframes fall-2 {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg) scale(1);
  }
  25% {
    transform: translateY(25vh) translateX(-15px) rotate(-15deg) scale(0.9);
  }
  50% {
    transform: translateY(50vh) translateX(12px) rotate(-30deg) scale(1.1);
  }
  75% {
    transform: translateY(75vh) translateX(-12px) rotate(-45deg) scale(0.95);
  }
  100% {
    transform: translateY(105vh) translateX(15px) rotate(-60deg) scale(1);
  }
}

@keyframes fall-3 {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg) scale(1);
  }
  25% {
    transform: translateY(25vh) translateX(5px) rotate(20deg) scale(1.05);
  }
  50% {
    transform: translateY(50vh) translateX(-10px) rotate(40deg) scale(0.92);
  }
  75% {
    transform: translateY(75vh) translateX(10px) rotate(60deg) scale(1.08);
  }
  100% {
    transform: translateY(105vh) translateX(-5px) rotate(80deg) scale(1);
  }
}
</style>